"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInsurerNameFromPolicyNumber = exports.getInsurerNameFromBrandId = exports.getInsurerNameFromTheme = exports.getPrettifiedInteractionBrandName = exports.getBrandFromPolicyNumber = void 0;
const getBrandFromPolicyNumber = (policyNumber) => {
    if (policyNumber.startsWith("VWA")) {
        return "Volkswagen";
    }
    else if (policyNumber.startsWith("AUD")) {
        return "Audi";
    }
    else if (policyNumber.startsWith("SKO")) {
        return "Škoda";
    }
    else if (policyNumber.startsWith("SEA")) {
        return "Seat";
    }
    else if (policyNumber.startsWith("CUP")) {
        return "Cupra";
    }
    else {
        return undefined;
    }
};
exports.getBrandFromPolicyNumber = getBrandFromPolicyNumber;
const getPrettifiedInteractionBrandName = (brandName) => {
    if (!brandName) {
        return "";
    }
    switch (brandName) {
        case "vw":
            return "Volkswagen";
        case "audi":
            return "Audi";
        case "skoda":
            return "Škoda";
        case "seat":
            return "Seat";
        case "cupra":
            return "Cupra";
        default:
            return brandName;
    }
};
exports.getPrettifiedInteractionBrandName = getPrettifiedInteractionBrandName;
const getInsurerNameFromTheme = (themeName) => {
    switch (themeName) {
        case "Volkswagen":
            return "LVIC - VW";
        case "Audi":
            return "LVIC - AUDI";
        case "Škoda":
            return "LVIC - SKODA";
        case "Seat":
            return "LVIC - SEAT";
        case "Cupra":
            return "LVIC - CUPRA";
        default:
            return `LVIC - ${themeName}`;
    }
};
exports.getInsurerNameFromTheme = getInsurerNameFromTheme;
const getInsurerNameFromBrandId = (brandName) => {
    switch (brandName) {
        case "vw":
            return "LVIC - VW";
        case "audi":
            return "LVIC - AUDI";
        case "skoda":
            return "LVIC - SKODA";
        case "seat":
            return "LVIC - SEAT";
        case "cupra":
            return "LVIC - CUPRA";
        default:
            return ``;
    }
};
exports.getInsurerNameFromBrandId = getInsurerNameFromBrandId;
const getInsurerNameFromPolicyNumber = (policyNumber) => {
    if (!policyNumber) {
        return "";
    }
    const polNumPrefix = policyNumber.substring(0, 3).toUpperCase();
    const brandMap = {
        VWA: "vw",
        AUD: "audi",
        SKO: "skoda",
        SEA: "seat",
        CUP: "cupra"
    };
    return (0, exports.getInsurerNameFromBrandId)(brandMap[polNumPrefix]);
};
exports.getInsurerNameFromPolicyNumber = getInsurerNameFromPolicyNumber;
//# sourceMappingURL=brandingHelper.js.map